import type { FC } from "react";

type CenterProps = {
  className?: string;
  [key: string]: any;
};

const Center: FC<CenterProps> = ({ className = "", ...props }) => {
  const classes = className
    ? `flex items-center justify-center ${className}`
    : "flex items-center justify-center";
  return <div className={classes} {...props} />;
};

export default Center;
